// User Management APIs

/**
 * @function ApiClient#GetUser
 * @this {ApiClient}
 * @param {any} options = {}
 */
export async function GetUser(options = {}) {
  return await this._get("/community/user", options);
}

/**
 * @function ApiClient#RegisterUser
 * @this {ApiClient}
 * @param {any} user
 * @param {any} code
 * @param {any} options = {}
 */
export async function RegisterUser(user, code, options = {}) {
  return await this._post(`/user?c=${code}`, user, options);
}

/**
 * @function ApiClient#ResetCommunityPassword
 * @this {ApiClient}
 * @param {any} code
 * @param {any} account
 * @param {any} mobile
 * @param {any} password
 * @param {any} options = {}
 */
export async function ResetCommunityPassword(code, account, mobile, password, options = {}) {
  return await this._post(`/reset_community_password?c=${code}&a=${account}&m=${mobile}&p=${password}`, null, options);
}
